import React, {Component} from 'react'

export default class Clients extends Component {
  constructor(props) {
    super(props);

    this.getLogos = this.getLogos.bind(this);
    this.logos = this.getLogos();
  }

  componentDidMount() {
    this.props.toggleWork(false);
  }

  getLogos() {
    const logoObject = this.importImages(require.context('../images/client_logos', false));
    let logoList = [];

    for (let key in logoObject) {
      if (logoObject.hasOwnProperty(key)) {
        logoList.push(logoObject[key]);
      }
    }

    return logoList;
  }

  importImages(r) {
    let images = {};
    r.keys().map((item, index) => { images[item.replace('./', '')] = r(item); });
    return images;
  }

  render() {
    return (
      <div className='clients-container'>
        <ul className='clients-grid' id='scroll'>
          {this.logos.map((logo) => {
            return (
              <li key={logo}>
                <div className='client-logo-container'>
                  <img src={logo} alt={'client logo'} />
                </div>
              </li>
            )
          })}
        </ul>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Clients.js